import axios from 'axios'

/**
 * API for getting list of tenants
 */
export const getListOfTenants = async () => {
  const response = await axios.get('tenants')
  return response
}

/**
 * API for switching tenant
 * @param {String} tenantId Tenant Id
 */
export const switchTenant = async (tenantId) => {
  const response = await axios.get(`tenants/switch?tenantId=${tenantId}`)
  return response
}
